import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

export const ProtectedValidator = ({ children }) => {
    const { auth } = useAuth()

    return auth.logged ? <Navigate to='/panel' /> : children
}
